import { useForm } from 'react-hook-form'
import useResize from '../../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../../utils/constants'
import { useTranslation } from 'react-i18next'
import BackUpIcon from '../../../../../../icons/BackUpIcon'
import DragDrop from '../../../../../../components/DragAndDrop'
import { ErrorMessage } from '@hookform/error-message'
import { useMutation } from '@tanstack/react-query'
import {
  uploadDescription,
  uploadVideo,
} from '../../../../../../services/HutritClub'
import Button from '../../../../../../components/Button'
import Toast from '../../../../../../components/Toast/Toast'
import { useHutritClubUploadTalentStore } from '../../../globalStore'

const initialValues = {
  category: '',
  videoFile: null,
  description: '',
}

const Delivery = () => {
  const { setCurrentStep } = useHutritClubUploadTalentStore()
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues: initialValues })
  const description = watch('description')

  const {
    mutate: uploadDescriptionMutate,
    isLoading: isLoadingUploadDescription,
  } = useMutation(['upload-description'], uploadDescription, {
    onSuccess: async ({ response, responseTwo }) => {
      if (response?.status !== 200) {
        Toast({
          icon: 'error',
          title: 'Error cargando el video/video ya cargado',
        })
      } else {
        const uploadDescriptionResponse = await uploadVideo(
          videoFile,
          responseTwo?.videoId
        )

        if (uploadDescriptionResponse?.response?.status === 200) {
          setCurrentStep(2)
        }
      }
    },
  })
  const videoFile = watch('videoFile')

  const IS_EMPTY_VIDEO_FILE = videoFile === null
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  //const isCustomChallenge = Number(selectedChallenge) === 2025

  const onSubmit = () => {
    uploadDescriptionMutate({
      description,
      categoryId: null,
      challengeHutritNextId: null,
    })
  }

  return (
    <div className="d-flex flex-column align-items-center mt-4 w-100 pb-4 px-lg-0 px-2">
      <div
        className={`${
          isMobile ? 'px-3' : 'px120'
        } py-4 d-flex flex-column align-items-center border border-2 rounded w-100 bg-bg-secondary gap-3`}
      >
        <div>
          <h2 className="text-on-bg-primary text-center fw-bold fontSize20">
            Entrega tu solución
          </h2>
          <h3 className="fontSize14 text-on-bg-primary">
            Sube tu video y describe tu proceso de pensamiento
          </h3>
        </div>
        <div
          className="px33 py-3 text-on-bg-primary bg-on-bg-brand rounded fontSize14 text-center"
          style={{
            border: '1px solid rgba(0, 207, 131, 0.20)',
          }}
        >
          No dejes pasar esta oportunidad.{' '}
          <strong>No te pedimos experiencia</strong>, te pedimos actitud,
          curiosidad y capacidad de resolver problemas reales. Hazlo bien y… el
          trabajo te encontrará a ti.
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="d-flex flex-column align-items-start gap-3 mt-2"
        >
          <div
            className={`${
              isMobile ? 'w-100 overflow-hidden mt-4' : 'w-100'
            } mb-3 d-flex flex-column`}
          >
            <input
              className="d-none"
              id="video-input"
              {...register('videoFile', {
                required: t('this_field_is_required'),
                validate: () => {
                  if (videoFile === 'File type is not supported') {
                    return t('the_file_type_is_not_supported')
                  }
                },
              })}
            ></input>
            <label className="text-on-bg-primary mb-2">Video del reto*</label>
            <DragDrop
              name="videoFile"
              customValue="videoFile"
              setValue={setValue}
              hoverTitle={t('drop_here')}
              fileTypes={[
                'mp4',
                'webm',
                'ogg',
                'avi',
                'mov',
                'wmv',
                'mkv',
                'flv',
              ]}
            >
              <div className="cursor-pointer drag-and-drop bg-bg-tertiary font-small p-3 d-flex justify-content-center align-items-center gap-2">
                <BackUpIcon />

                {IS_EMPTY_VIDEO_FILE ? (
                  <div className="d-flex flex-column justify-content-center align-items-start">
                    <div className="d-flex align-items-center gap-1">
                      <span className="text-decoration-underline text-bg-CTA-primary">
                        {t('goes_up')}{' '}
                      </span>
                      <span className="text-on-bg-primary">
                        o arrastra el video
                      </span>
                    </div>
                    <span className="text-on-bg-secondary">
                      {t('accepted_formats')}: MP4, MOV, AVI (máx. 500MB)
                    </span>
                  </div>
                ) : (
                  <span className="text-bg-CTA-primary fw-bolder">
                    {t('file_uploaded_successfully')}
                  </span>
                )}
              </div>
            </DragDrop>
            <ErrorMessage
              errors={errors}
              name="videoFile"
              render={({ message }) => (
                <span className="text-danger font-small">{message}</span>
              )}
            />
          </div>
          <div className="w-100">
            <label className="form-label">
              Describe tu proyecto*
            </label>
            <textarea
              className="form-control w-100"
              {...register('description')}
            />
          </div>
          <div className="d-flex align-items-center justify-content-center w-100">
            <Button
              type="submit"
              className="btn-bg-CTA-primary text-on-bg-primary p-3"
            >
              {isLoadingUploadDescription
                ? 'Guardando...'
                : 'Guardar y entregar reto'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Delivery
